var map = {
	"./euro2024.webp": 1580,
	"./euro2024_title.svg": 1581,
	"./event-sport-bg.jpg": 1582,
	"./event-sport-bg.png": 1583,
	"./home-icon-active.webp": 1584,
	"./home-icon.webp": 1585,
	"./img_bg-uefa.png": 1586,
	"./live-icon-active.webp": 1587,
	"./master-bg.webp": 1588,
	"./me-icon-active.webp": 1589,
	"./product-overview-bg.webp": 1590,
	"./promos-icon-active.webp": 1591,
	"./sponsor-icon-active.webp": 1592,
	"./uefa-icon-active.webp": 1593,
	"./uefa-icon.webp": 1594,
	"./uefa-prediction.webp": 1595,
	"./wwr-img.webp": 1596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 205;